import { writable } from 'svelte/store';

import type { PaypalInfoResponse } from 'src/types/Subscription';

export const rating_prompt_status = writable(false);
export const isRateUsClicked = writable(false);
export const paypal_info = writable<PaypalInfoResponse>({} as PaypalInfoResponse);

export const testDemoPromotionsModals = writable({
	birthday: false,
	black_friday: false,
});

export const scrollToPremiumSubs = writable<boolean>(false);
